module.exports = __webpack_public_path__ + "static/img/11.b311e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/11.png
// module id = O7eX
// module chunks = 1